<template>
  <div>
      <h2>我的资料</h2>
      <a-divider></a-divider>
      <UserInfo/>
  </div>
</template>

<script>
import UserInfo from "@/components/user/UserInfo.vue"
export default {
  components:{
    UserInfo
  }
}
</script>

<style>

</style>